import { useCallback, useState } from "react"
import { cn } from "@/lib/utils"
import { MetricsGrid, type MetricEntry } from "../MetricsGrid/MetricsGrid"

export interface SummaryMetricsTab {
  id: string
  label: string
  metrics: MetricEntry[]
}

export interface SummaryMetricsProps {
  tabs: SummaryMetricsTab[]
  activeTabId?: string
  defaultTabId?: string
  onTabChange?: (tabId: string) => void
  className?: string
}

export function SummaryMetrics({
  tabs,
  activeTabId: controlled,
  defaultTabId,
  onTabChange,
  className,
}: SummaryMetricsProps) {
  const [internal, setInternal] = useState<string>(
    defaultTabId ?? tabs[0]?.id ?? "",
  )
  const active = controlled ?? internal

  const handleSelect = useCallback(
    (id: string) => {
      setInternal(id)
      onTabChange?.(id)
    },
    [onTabChange],
  )

  const current = tabs.find((t) => t.id === active) ?? tabs[0]

  return (
    <div className={cn("border-b border-border", className)}>
      <div className="flex items-center gap-4 px-4 border-b border-border shrink-0 h-11">
        {tabs.map((t) => {
          const isActive = t.id === current?.id
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => handleSelect(t.id)}
              className={cn(
                "text-caption pb-1 cursor-pointer transition-colors border-b-[1.5px]",
                isActive
                  ? "font-medium text-foreground border-foreground"
                  : "font-normal text-muted-foreground border-transparent hover:text-foreground",
              )}
            >
              {t.label}
            </button>
          )
        })}
      </div>

      {current && <MetricsGrid metrics={current.metrics} />}
    </div>
  )
}
